export interface ChartColors {
  primary: string;
  secondary: string;
  accent: string;
  success: string;
  warning: string;
  error: string;
  grid: string;
  text: string;
  background: string;
  tooltip: {
    background: string;
    border: string;
    text: string;
  };
}

export const getChartColors = (isDark: boolean): ChartColors => {
  if (isDark) {
    return {
      primary: '#60a5fa',      // primary-400
      secondary: '#34d399',    // secondary-400
      accent: '#c084fc',       // accent-400
      success: '#4ade80',      // success-400
      warning: '#fbbf24',      // warning-400
      error: '#f87171',        // error-400
      grid: '#374151',         // neutral-700
      text: '#d1d5db',         // neutral-300
      background: '#1f2937',   // neutral-800
      tooltip: {
        background: '#374151', // neutral-700
        border: '#4b5563',     // neutral-600
        text: '#f9fafb'        // neutral-50
      }
    };
  }

  return {
    primary: '#3b82f6',       // primary-500
    secondary: '#10b981',     // secondary-500
    accent: '#a855f7',        // accent-500
    success: '#22c55e',       // success-600
    warning: '#f59e0b',       // warning-500
    error: '#ef4444',         // error-500
    grid: '#e5e7eb',          // neutral-200
    text: '#374151',          // neutral-700
    background: '#ffffff',    // white
    tooltip: {
      background: '#ffffff',  // white
      border: '#e5e7eb',      // neutral-200
      text: '#111827'         // neutral-900
    }
  };
};

// Default color palette for charts with multiple series
export const getDefaultColorPalette = (isDark: boolean): string[] => {
  const colors = getChartColors(isDark);
  return [
    colors.primary,
    colors.secondary,
    colors.accent,
    colors.success,
    colors.warning,
    colors.error,
    '#8b5cf6', // violet-500
    '#06b6d4', // cyan-500
    '#f97316', // orange-500
    '#84cc16'  // lime-500
  ];
};
